import { render } from "./ApexChartsPage.vue?vue&type=template&id=a0f3d018&ts=true"
import script from "./ApexChartsPage.vue?vue&type=script&lang=ts"
export * from "./ApexChartsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__